<div class="activity-detail-page">

    @if (isLoading) {
  
      <div class="detail-loading">
        Cargando actividad...
      </div>
  
    } @else {
  
      @if (activity) {
  
        <a
        class="back-link"
        routerLink="/activity-list"
        >
        ← Volver a actividades
        </a>

        <section class="detail-hero">
  
          <div>
            <span class="eyebrow">
              Administración de actividad
            </span>
  
            <h1>
              {{ activity.title }}
            </h1>
  
            <p>
              {{ activity.description || 'Sin descripción' }}
            </p>
          </div>
  
          <div class="detail-summary">

            <div>
              <span class="summary-label">
                Tipo
              </span>
          
              <strong>
                {{ activity.type }}
              </strong>
            </div>
          
            <div>
              <span class="summary-label">
                Valor
              </span>
          
              <strong>
                {{ activity.valueInHours }} h
              </strong>
            </div>
          
            <div>
              <span class="summary-label">
                Fecha de inicio
              </span>
          
              <strong>
                {{ activity.startDate | date:'dd MMM yyyy' }}
              </strong>
            </div>
          
            <div>
              <span class="summary-label">
                Fecha límite
              </span>
          
              <strong>
                {{ activity.dueDate | date:'dd MMM yyyy' }}
              </strong>
            </div>
          
            <div>
              <span class="summary-label">
                Horario
              </span>
          
              @if (activity.startTime && activity.endTime) {
                <strong>
                  {{ activity.startTime }} - {{ activity.endTime }}
                </strong>
              } @else {
                <strong>
                  No especificado
                </strong>
              }
            </div>
          
          </div>
  
        </section>
  
  
        <section class="participants-card">
  
          <div class="participants-header">
  
            <div>
              <span class="section-eyebrow">
                Participación
              </span>
  
              <h2>
                Participantes registrados
              </h2>
              <p>
                Consulta quiénes están inscritos en esta actividad.
              </p>
            </div>
  
            <div class="participants-count">
              <strong>
                {{ registeredStudents.length }}
              </strong>
  
              <span>
                {{
                  registeredStudents.length === 1
                    ? 'participante'
                    : 'participantes'
                }}
              </span>
            </div>
  
          </div>
  
  
          @if (registeredStudents.length > 0) {
  
            <div class="participants-list">
  
              @for (student of registeredStudents; track student.id) {
  
                <article class="participant-row">

                  <div class="participant-header">
  
                  <div class="participant-avatar">
                    {{
                      student.fullName
                        ? student.fullName.charAt(0).toUpperCase()
                        : '?'
                    }}
                  </div>
  
  
                  <div class="participant-main">
  
                    <h3>
                      {{ student.fullName || 'Sin nombre' }}
                    </h3>
  
                    <span>
                      {{ student.mail }}
                    </span>

                    @if (getParticipantFolio(student); as inscFolio) {
                      <!-- C3.2: banner de folio de inscripción del participante -->
                      <div class="inscription-folio-banner">
                        <span class="inscription-folio-text">
                          Tu Folio de Inscripción es:
                        </span>

                        <app-folio-pill
                          [folio]="inscFolio"
                          [interactionType]="getParticipantFolioType(student)"
                          [showHours]="false"
                        ></app-folio-pill>
                      </div>
                    }
  
                  </div>
  
  
                  <div class="participant-meta">
  

                    <div>
                      <span class="meta-label">
                        Escuela
                      </span>
  
                      <strong>
                        {{ student.school || 'N/A' }}
                      </strong>
                    </div>
  
                    <div>
                      <span class="meta-label">
                        Carrera
                      </span>
  
                      <strong>
                        {{ student.career || 'N/A' }}
                      </strong>
                    </div>
  
                    <div>
                      <span class="meta-label">
                        Semestre
                      </span>
  
                      <strong>
                        {{ student.semester || 'N/A' }}
                      </strong>
                    </div>
  
                  </div>

                  </div>

                  <div class="participation-control">

                    <div class="participation-control-header">
                  
                      <div>
                        <span class="control-label">
                          Estado de participación
                        </span>
                  
                        <div
                          class="status-chip"
                          [class.status-registered]="getParticipationStatus(student) === 'registered'"
                          [class.status-attended]="getParticipationStatus(student) === 'attended'"
                          [class.status-absent]="getParticipationStatus(student) === 'absent'"
                          [class.status-validated]="getParticipationStatus(student) === 'validated'"
                        >
                          @switch (getParticipationStatus(student)) {
                  
                            @case ('registered') {
                              Registrado
                            }
                  
                            @case ('attended') {
                              Asistió
                            }
                  
                            @case ('absent') {
                              No asistió
                            }
                  
                            @case ('validated') {
                              Horas validadas
                            }
                  
                          }
                        </div>
                      </div>
                  
                  
                      @if (getParticipationStatus(student) === 'validated') {

                        <div class="validated-summary">
                          <span>Horas acreditadas</span>
                      
                          <strong>
                            {{ getValidatedHours(student) }} h
                          </strong>
                        </div>
                      
                      }
                  
                    </div>
                  
                  
                    <div class="participant-actions">
                  
                      <div class="attendance-actions">
                  
                        <span class="action-group-label">
                          Asistencia
                        </span>
                  
                        <div class="action-buttons">
                  
                          <button
                            type="button"
                            class="status-button attended-button"
                            [class.active-attended]="getParticipationStatus(student) === 'attended'"
                            [disabled]="getParticipationStatus(student) === 'validated'"
                            (click)="updateStatus(student.id, 'attended')"
                          >
                            ✓ Asistió
                          </button>
                  
                  
                          <button
                            type="button"
                            class="status-button absent-button"
                            [class.active-absent]="getParticipationStatus(student) === 'absent'"
                            [disabled]="getParticipationStatus(student) === 'validated'"
                            (click)="updateStatus(student.id, 'absent')"
                          >
                            ✕ No asistió
                          </button>
                  
                        </div>
                  
                      </div>
                  
                      @if (
                      student.participantType === 'student' ||
                      student.volunteerType === 'SERVICE_SOCIAL'
                    ) {

                  
                      <div class="validation-action">

                        <span class="action-group-label">
                          Acreditación
                        </span>
                      
                        @if (getParticipationStatus(student) === 'validated') {
                      
                          <button
                            type="button"
                            class="status-button validate-button active-validated"
                            disabled
                          >
                            ✓ {{ getValidatedHours(student) }} h validadas
                          </button>
                      
                        } @else {
                      
                          <div class="remaining-hours-box">
                      
                            <span>
                              Horas pendientes
                            </span>
                      
                            <strong>
                              {{ getRemainingHours(student) }} h
                            </strong>
                      
                            <small>
                              de {{ student.horasCubrir }} h requeridas
                            </small>
                      
                          </div>
                      
                          <div class="validation-input-group">
                      
                            <label
                              class="validation-input-label"
                              [for]="'validatedHours-' + student.id"
                            >
                              Horas a acreditar
                            </label>
                      
                            <div
                              class="validation-input-row"
                              [class.input-over-limit]="
                                validatedHoursInput[student.id] !== null &&
                                validatedHoursInput[student.id] !== undefined &&
                                validatedHoursInput[student.id]! > getRemainingHours(student)
                              "
                            >
                      
                              <input
                                [id]="'validatedHours-' + student.id"
                                type="number"
                                min="0.5"
                                [max]="getRemainingHours(student)"
                                step="0.5"
                                class="validation-hours-input"
                                [value]="validatedHoursInput[student.id] ?? ''"
                                [disabled]="
                                  getParticipationStatus(student) !== 'attended' ||
                                  getRemainingHours(student) <= 0
                                "
                                (input)="
                                  validatedHoursInput[student.id] =
                                    $any($event.target).value === ''
                                      ? null
                                      : +$any($event.target).value
                                "
                                placeholder="0"
                              />
                      
                              <span class="validation-hours-unit">
                                h
                              </span>
                      
                            </div>
                      
                            @if (
                              validatedHoursInput[student.id] !== null &&
                              validatedHoursInput[student.id] !== undefined &&
                              validatedHoursInput[student.id]! > getRemainingHours(student)
                            ) {
                      
                              <span class="validation-limit-error">
                                Máximo permitido:
                                {{ getRemainingHours(student) }} h
                              </span>
                      
                            }
                      
                            @if (getRemainingHours(student) <= 0) {
                      
                              <span class="validation-complete-message">
                                ✓ El estudiante ya completó sus horas requeridas.
                              </span>
                      
                            }
                      
                          </div>
                      
                          <button
                            type="button"
                            class="status-button validate-button"
                            [disabled]="
                              !canValidateHours(student) ||
                              getParticipationStatus(student) !== 'attended'"
                            (click)="openValidateConfirmation(student)"
                          >
                            @if (
                              validatedHoursInput[student.id] !== null &&
                              validatedHoursInput[student.id] !== undefined
                            ) {
                              Validar {{ validatedHoursInput[student.id] }} h
                            } @else {
                              Validar horas
                            }
                          </button>
                      
                        }
                      
                      </div>
                    }
                    </div>
                  
                  </div>
  
                </article>
  
              }
  
            </div>
  
          } @else {
  
            <div class="empty-participants">
  
              <h3>
                Aún no hay estudiantes registrados
              </h3>
  
              <p>
                Cuando un estudiante se registre,
                aparecerá automáticamente aquí.
              </p>
  
            </div>
  
          }
  
        </section>
  
      } @else {
  
        <div class="detail-error">
          No se pudo cargar la actividad.
        </div>
  
      }
  
    }
  
</div>

@if (
  showValidateConfirmation &&
  studentToValidate &&
  hoursToConfirm !== null
) {

  <div
    class="confirmation-overlay"
    (click)="closeValidateConfirmation()"
  >

    <div
      class="confirmation-modal"
      (click)="$event.stopPropagation()"
    >

      <div class="confirmation-icon validation-confirmation-icon">
        ✓
      </div>

      <h2>
        ¿Validar {{ hoursToConfirm }} {{ getHoursLabel(hoursToConfirm) }}?
      </h2>

      <p>
        Estás a punto de acreditar
        <strong>{{ hoursToConfirm }} h</strong>
        a
        <strong>{{ studentToValidate.fullName }}</strong>
        por la actividad
        <strong>{{ activity?.title }}</strong>.
      </p>

      <p class="confirmation-warning">
        Una vez validadas, estas horas no podrán modificarse.
      </p>

      <div class="performance-section">
        <span class="performance-label">
          Desempeño del participante
        </span>
      
        <div class="performance-options">
          <button
            type="button"
            class="performance-option"
            [class.selected]="
              performanceInput[studentToValidate.id] === 'very_bad'
            "
            (click)="performanceInput[studentToValidate.id] = 'very_bad'"
          >
            Muy malo
          </button>
      
          <button
            type="button"
            class="performance-option"
            [class.selected]="
              performanceInput[studentToValidate.id] === 'bad'
            "
            (click)="performanceInput[studentToValidate.id] = 'bad'"
          >
            Malo
          </button>
      
          <button
            type="button"
            class="performance-option"
            [class.selected]="
              performanceInput[studentToValidate.id] === 'good'
            "
            (click)="performanceInput[studentToValidate.id] = 'good'"
          >
            Bueno
          </button>
      
          <button
            type="button"
            class="performance-option"
            [class.selected]="
              performanceInput[studentToValidate.id] === 'very_good'
            "
            (click)="performanceInput[studentToValidate.id] = 'very_good'"
          >
            Muy bueno
          </button>
      
          <button
            type="button"
            class="performance-option"
            [class.selected]="
              performanceInput[studentToValidate.id] === 'excellent'
            "
            (click)="performanceInput[studentToValidate.id] = 'excellent'"
          >
            Excelente
          </button>
        </div>
      </div>
      
      <div class="performance-comment-section">
        <label
          class="performance-comment-label"
          [for]="'performanceComment-' + studentToValidate.id"
        >
          Comentarios
          <span>(opcional)</span>
        </label>
      
        <textarea
          [id]="'performanceComment-' + studentToValidate.id"
          class="performance-comment-input"
          [value]="performanceCommentInput[studentToValidate.id] || ''"
          (input)="
            performanceCommentInput[studentToValidate.id] =
              $any($event.target).value
          "
          rows="3"
          placeholder="Escribe un comentario sobre el desempeño del participante..."
        ></textarea>
      </div>

      <div class="confirmation-actions">

        <button
          type="button"
          class="confirmation-cancel-button"
          [disabled]="isValidating"
          (click)="closeValidateConfirmation()"
        >
          Cancelar
        </button>

        <button
          type="button"
          class="confirmation-validate-button"
          [disabled]="
            isValidating ||
            !performanceInput[studentToValidate.id]
          "
          (click)="confirmValidateHours()"
        >

          @if (isValidating) {
            <span class="validation-loading">
              <span class="validation-spinner"></span>
              Validando...
            </span>
          } @else {
            Validar {{ hoursToConfirm }} h
          }

        </button>

      </div>

    </div>

  </div>

}